import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Box } from '../../components';
import { PageWithTabs } from '../../layouts';
import ContentManagementForm from '../../forms/contentManagement/ContentManagementForm';
import { Query } from 'react-apollo';
import GetShop from '../../graphql/queries/GetShop';

type Props = RouteComponentProps<MatchParams>;

type MatchParams = {
  step: string;
  id?: string;
};

const SERVICES_TABS = [
  { title: 'Details', to: (id?: string) => `/content-management/services/${id ? id : 'create-new'}/details` },
];

const CreateEditService: React.FC<Props> = (props) => {
  const { match, location } = props;
  const isEditing = !location.pathname.includes('create-new');

  return (
    <PageWithTabs
      tabs={SERVICES_TABS.map((tab) => ({
        ...tab,
        to: typeof tab.to === 'function' ? tab.to(match.params.id) : tab.to,
      }))}
      alignItems="inherit"
    >
      <Box flexDirection="row" p={4}>
        {isEditing ? (
          <Query query={GetShop} variables={{ id: match.params.id }}>
            {({ loading, error, data }) => (
              <ContentManagementForm
                initialValues={data.shop || {}}
                loading={loading}
                isNewPost={false}
                step="services"
                formType="edit"
              />
            )}
          </Query>
        ) : (
          <ContentManagementForm
            initialValues={{}}
            loading={false}
            isNewPost={true}
            step="services"
            formType="create"
          />
        )}
      </Box>
    </PageWithTabs>
  );
};

export default CreateEditService;



// WEBPACK FOOTER //
// ./src/containers/contentManagement/CreateEditService.tsx